import { TicketType } from '@cbgms/api'

export const hasVehicleFields = (t: TicketType) => {
  return !![TicketType.VehicleRelatedQuestion, TicketType.PartVehicleLinkageQuestion, TicketType.PartAvailability].find(n => n === t)
}

export const hasPartFields = (t: TicketType) => {
  return !![
    TicketType.PartRelatedQuestion,
    TicketType.PartAvailability,
    TicketType.CallMeBackRequest,
    TicketType.PartVehicleLinkageQuestion
  ].find(n => n === t)
}

export const hasContactPreferenceFields = (t: TicketType) => {
  return !![TicketType.PartAvailability, TicketType.CallMeBackRequest].find(n => n === t)
}

export const hasQuestionField = (t: TicketType) => {
  return !![
    TicketType.GeneralTicket,
    TicketType.ITRelatedQuestion,
    TicketType.PartAvailability,
    TicketType.PartRelatedQuestion,
    TicketType.PartVehicleLinkageQuestion,
    TicketType.Suggestion,
    TicketType.VehicleRelatedQuestion
  ].find(n => n === t)
}
